import * as TabsPrimitive from "@radix-ui/react-tabs";
import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";

export function Tabs({ className, ...props }: ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root className={cn("flex min-w-0 flex-col gap-3", className)} data-slot="tabs" {...props} />;
}

export function TabsList({ className, variant = "default", ...props }: ComponentProps<typeof TabsPrimitive.List> & { variant?: "default" | "line" }) {
  return <TabsPrimitive.List
    className={cn(
      "group/tabs-list inline-flex w-fit items-center gap-1",
      variant === "line" ? "h-11 rounded-none bg-transparent p-0" : "rounded-xl border border-border/80 bg-muted/80 p-1",
      className,
    )}
    data-slot="tabs-list"
    data-variant={variant}
    {...props}
  />;
}

export function TabsTrigger({ className, ...props }: ComponentProps<typeof TabsPrimitive.Trigger>) {
  return <TabsPrimitive.Trigger
    className={cn(
      "inline-flex h-9 shrink-0 cursor-pointer items-center justify-center gap-2 rounded-lg px-3.5 text-sm leading-none font-medium whitespace-nowrap text-muted-foreground outline-none transition-[color,background-color,box-shadow] hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/15 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm sm:px-5 [&_svg]:size-4 [&_svg]:shrink-0",
      "group-data-[variant=line]/tabs-list:h-11 group-data-[variant=line]/tabs-list:rounded-none group-data-[variant=line]/tabs-list:border-b-2 group-data-[variant=line]/tabs-list:border-transparent group-data-[variant=line]/tabs-list:focus-visible:ring-inset group-data-[variant=line]/tabs-list:focus-visible:ring-offset-0 group-data-[variant=line]/tabs-list:data-[state=active]:border-primary group-data-[variant=line]/tabs-list:data-[state=active]:text-primary group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none",
      className,
    )}
    data-slot="tabs-trigger"
    {...props}
  />;
}

export function TabsContent({ className, ...props }: ComponentProps<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content
    className={cn("min-w-0 rounded-xl outline-none focus-visible:ring-2 focus-visible:ring-ring/15 focus-visible:ring-offset-2 data-[state=inactive]:hidden", className)}
    data-slot="tabs-content"
    {...props}
  />;
}
